import React from "react"
import { OMSPlayStoreURL } from "../constants/AppConstants";
import { Linking, Pressable, View, Text, Image, TouchableOpacity, Switch } from "react-native";
import { View as AnimatableView } from "react-native-animatable";

import { isFirefox } from "react-device-detect";
import { handleBackPress } from "../../screens/CommonService";
import { getImagePath, updateOptInState } from "../services/CommonUtils";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import Colors from "../constants/AppColors";

import * as MoenegeUtils from "../services/webapp-services/MoengageUtils";

export class GoogleOMSBadge extends React.Component {
    render() {
        return <Pressable onPress={() => {
            Linking.openURL(OMSPlayStoreURL).catch((err) =>
                console.error('An error occured', err));
        }} onLongPress={() => { console.log('### long press') }}><View>
                <Image source={{ uri: getImagePath('/images/oms-banner.webp'), height: AppTheme.appWidth * 0.35 }}></Image>
            </View>
        </Pressable>
    }
}

export function OrganisationStatsView(stat, title) {
    return <View style={{ alignItems: 'center' }}>
        <Text style={TextStyle.text20xb}>{stat} +</Text>
        <Text style={TextStyle.text12}>{title}</Text>
    </View>
}

export const SupportView = (props) => {
    return <TouchableOpacity style={[AppStyles.flexRow]}
        onPress={() => { props.showSupportModal() }}>
        <Text style={[TextStyle.text14xb, { marginLeft: 4, color: AppTheme.color.primary }]}>
            Need Help?</Text>
    </TouchableOpacity>
}

export function CallPharmacy(pharmacyDetails, icon, iconSize = 18) {
    return <TouchableOpacity style={[AppStyles.flexRow]}
        onPress={() => {
            MoenegeUtils.trackMoengageEvents(MoenegeUtils.MoengageEvents.oms_chat_call);
            Linking.openURL(`tel:${pharmacyDetails['phoneNumber']}`)
        }}>
        <Image source={{ uri: getImagePath(icon), width: iconSize, height: iconSize }} />
    </TouchableOpacity>
}

export function AddMember(addMember) {
    return <Pressable style={[AppStyles.flexRowEnd]}
        onPress={() => { addMember() }} onLongPress={() => { console.log('### long press') }}>
        <Image source={{ uri: getImagePath('/images/icons/add_blue.svg'), width: 18, height: 18 }} />
        <Text style={[TextStyle.text14xb, { color: Colors.primary, marginLeft: 4 }]}>Add Member</Text></Pressable>
}

export function DashboardFeatureCard(title, image, backgroundColor) {
    return <View style={[AppStyles.mediumShadow, { marginHorizontal: 16, borderRadius: 12 }]} >

        <View style={{
            zIndex: 4, position: 'absolute', shadowOpacity: 0.12, shadowColor: Colors.black, shadowRadius: 4, shadowOffset: { width: 1, height: 3 },
            borderTopLeftRadius: 12, borderTopRightRadius: 12
        }}>
            <Image source={{ uri: getImagePath('/images/' + image + '.png') }}
                style={[{
                    width: AppTheme.appWidth - 32, height: (AppTheme.appWidth - 32) * 0.35,
                    borderTopLeftRadius: 12, borderTopRightRadius: 12, paddingBottom: 8
                }]} /></View>

        <View style={[AppStyles.flexRowCenter, {
            backgroundColor: backgroundColor, justifyContent: 'flex-start', paddingHorizontal: 16,
            paddingTop: (AppTheme.appWidth - 32) * 0.35, height: (AppTheme.appWidth - 32) * 0.35 + 40,
            borderTopLeftRadius: 20, borderTopRightRadius: 20, borderBottomLeftRadius: 12, borderBottomRightRadius: 12
        }]}>

            <Text style={[TextStyle.text14xb, { color: 'white', paddingRight: 8, paddingBottom: 2 }]}>
                {title}</Text>

            <Image source={{
                uri: getImagePath('/images/icons/right_chevron_circle_white.svg'),
                width: 14, height: 14
            }} />

        </View>

    </View>
}

export function OrderCTA(title, image, backgroundColor, width, disabled = false) {
    return <View style={[AppStyles.flexRowCenter, {
        backgroundColor: backgroundColor,
        width: width, paddingVertical: 8, alignContent: "center", borderRadius: 40
    }]}>

        <Image source={{ uri: getImagePath('/images/icons/' + image + '.svg'), width: 19, height: 19 }} />
        <Text style={[TextStyle.text14xb, { color: 'white', marginTop: isFirefox ? 2 : 0, marginLeft: 4 }]}>{title}</Text></View>
}

export const CommonBackIcon = (props) => {
    return <Text style={{ width: AppTheme.backPressIcon }}
        onPress={() => { props?.handleBackPress ? props?.handleBackPress() : handleBackPress(props) }}>
        <Image style={{ marginTop: 4, width: 18, height: 18 }}
            source={{ uri: getImagePath('/images/icons/left_arrow_black.svg') }} /></Text>
}

export function WAUpdateToggleView(props) {
    return <View>
        {props?.waState.optInState == 1 ? <View /> :
            <AnimatableView animation="zoomIn" useNativeDriver
                duration={AppTheme.transitionDuration / 2}
                delay={AppTheme.transitionDuration} >
                <View style={[AppStyles.flexRowSpaceBetween, AppStyles.mediumShadow, AppStyles.p16,
                { borderRadius: 12, width: AppTheme.appWidth - 32, backgroundColor: 'white' }]}>
                    <Image style={{ marginRight: 8 }} source={{ uri: getImagePath('/images/icons/whatsapp/encircled.svg'), width: 40, height: 40 }} />
                    <Text style={[TextStyle.text14xb, {}]}>Get {props?.activity} updates on your WhatsApp</Text>
                    <Switch style={{ marginLeft: 32 }} onValueChange={() => {
                        updateOptInState(props?.waState,
                            props?.updateWAState, props?.activity)
                    }} value={props?.waState.isOpted}
                        trackColor={{ true: 'lightblue', false: 'grey' }} /></View>
            </AnimatableView>}
    </View>
}

export const AutoColorTypedStringView = (index, typedString, fullString) => {
    var indexOf = fullString.toLocaleLowerCase().indexOf(typedString.toLocaleLowerCase())
    var splitedStringList: String[] = []
    if (indexOf == -1) {
        splitedStringList.push(fullString)
        splitedStringList.push('')
        splitedStringList.push('')
    } else {
        splitedStringList.push(fullString.substring(0, indexOf))
        splitedStringList.push(fullString.substring(indexOf, indexOf + typedString.length))
        splitedStringList.push(fullString.substring(typedString.length))
    }
    return <Text key={index} numberOfLines={1} ellipsizeMode="tail"
        style={[TextStyle.text16b, { width: AppTheme.appWidth - 90, letterSpacing: 0 }]}>
        <Text>{splitedStringList[0]}</Text><Text style={{ color: AppTheme.color.grey.text }}>
            {splitedStringList[1]}</Text>{splitedStringList[2]}</Text>
}

export const CommonRightChevronIcon = (iconColor = 'blue', resize = 1) => {
    return <Image style={{ height: 11 * resize, width: 7 * resize }}
        source={{
            uri: getImagePath('/images/icons/right_chevron_' + iconColor + '.svg')
        }} />
}

export const RightArrowIcon = (props) => {
    let resize = props.resize ?? 1
    let tintColor = props.tintColor ?? 'white'
    return <Image style={{ tintColor: tintColor, height: 13 * resize, width: 18 * resize }}
        source={{ uri: getImagePath('/images/icons/right_arrow_white.svg') }} />
}

export const VerticalDivider = (props) => {
    const dividerHeight = props.height
    const dividerWidth = props?.width ?? 1
    let marginLeft = props?.marginHorizontal ?? 0
    let marginRight = props?.marginHorizontal ?? 0
    if (props?.marginLeft) marginLeft = props.marginLeft
    if (props?.marginRight) marginRight = props.marginRight
    return <View style={[{
        height: dividerHeight, width: dividerWidth,
        marginLeft: marginLeft, marginRight: marginRight,
        backgroundColor: AppTheme.color.grey.divider, alignSelf: "center"
    }]} />
}

export const HorizontalDivider = (props) => {
    const dividerWidth = props.width
    const dividerHeight = props?.height ?? 1
    let marginTop = props?.marginVertical ?? 0
    let marginBottom = props?.marginVertical ?? 0
    if (props?.marginTop) marginTop = props.marginTop
    if (props?.marginBottom) marginBottom = props.marginBottom
    return <View style={[{
        height: dividerHeight, width: dividerWidth,
        marginTop: marginTop, marginBottom: marginBottom,
        backgroundColor: AppTheme.color.grey.divider, alignSelf: "center"
    }]} />
}

export const CloseIcon = (props) => {
    let resize = props.resize ?? 1
    let tintColor = props.tintColor ?? 'black'
    return <Pressable onPress={props?.action ?? props.onPress}
        onLongPress={() => { console.log('### long press') }}>
        <Image source={{ uri: getImagePath('/images/icons/close.svg') }}
            style={{ tintColor: tintColor, height: 18 * resize, width: 18 * resize }} />
    </Pressable>
}


export const BulletedDotView = (props) => {
    let width = props.size ?? 4
    let height = props.size ?? 4
    let marginLeft = props?.marginHorizontal ?? props.marginLeft ?? 0
    let marginRight = props?.marginHorizontal ?? props.marginRight ?? 0
    let backdropColor = props.backgroundColor ?? Colors.black
    return <View style={{
        height: height, width: width, borderRadius: height / 2,
        marginRight: marginRight, marginLeft: marginLeft,
        backgroundColor: backdropColor
    }} />
}